const TripPlanningType = Object.freeze({
  DESTINATION_IN_MIND: 'destination_in_mind',
  MULTI_STOP: 'multi_stop',
  ROAD_TRIP: 'road_trip',
  HELP_ME_DECIDE: 'help_me_decide',
} as const);

export type TripPlanningType =
  (typeof TripPlanningType)[keyof typeof TripPlanningType];

export const allTripPlanningTypes = [
  TripPlanningType.DESTINATION_IN_MIND,
  TripPlanningType.MULTI_STOP,
  TripPlanningType.ROAD_TRIP,
  TripPlanningType.HELP_ME_DECIDE,
] as const;

export default TripPlanningType;